export enum VisionNumberFormatType {
  COMMA = 'comma',
  PERIOD = 'period',
}
